import { useAppUser } from '@bechtel/client-common';
import { AuthPermission, AuthScope } from '@bechtel/types';
import React from 'react';

export function useProjectAdminPermissions() {
  const { hasPermissionScope } = useAppUser();
  const projectAdminPermissions = React.useMemo(() => {
    const canViewProjectAdmin = hasPermissionScope({
      permission: AuthPermission.PROJECT_CONFIGURATION,
      scope: AuthScope.APPLICATION,
    });
    return { canViewProjectAdmin };
  }, [hasPermissionScope]);
  return projectAdminPermissions;
}

export function useProjectAdminTabPermissions() {
  const { hasPermissionScope } = useAppUser();

  const tabPermissions = React.useMemo(() => {
    const canViewGeneral = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_GENERAL,
      scope: AuthScope.APPLICATION,
    });

    const canViewUserAdmin =
      hasPermissionScope({
        permission: AuthPermission.VIEW_ADMIN_USERS,
        scope: AuthScope.APPLICATION,
      }) ||
      hasPermissionScope({
        permission: AuthPermission.VIEW_ADMIN_USERS,
        scope: AuthScope.EDIT,
      });

    const canEditUserAdmin = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_USERS,
      scope: AuthScope.EDIT,
    });

    const canManageUserAdminFully = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_USERS,
      scope: AuthScope.APPLICATION,
    });

    const canViewModules = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_MODULES,
      scope: AuthScope.APPLICATION,
    });

    const canViewFeatures = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_FEATURES,
      scope: AuthScope.APPLICATION,
    });

    const canViewWorkPackages = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_WORK_PACKAGES,
      scope: AuthScope.APPLICATION,
    });

    const canViewQuantityReporting = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_QUANTITY_REPORTING,
      scope: AuthScope.APPLICATION,
    });

    const canViewSync = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_SYNC,
      scope: AuthScope.APPLICATION,
    });

    const canViewReports = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_REPORTS,
      scope: AuthScope.APPLICATION,
    });

    const canViewImports = hasPermissionScope({
      permission: AuthPermission.VIEW_ADMIN_IMPORTS,
      scope: AuthScope.APPLICATION,
    });

    return {
      canViewGeneral,
      canViewUserAdmin,
      canEditUserAdmin,
      canManageUserAdminFully,
      canViewModules,
      canViewFeatures,
      canViewWorkPackages,
      canViewQuantityReporting,
      canViewSync,
      canViewReports,
      canViewImports,
    };
  }, [hasPermissionScope]);

  return tabPermissions;
}
